import React from 'react';

interface SafariSkipIconProps {
  direction: 'back' | 'forward';
  className?: string;
  style?: React.CSSProperties;
}

// Ícone estilo iOS/Safari (gobackward.10 / goforward.10): seta circular com o
// número "10" no centro. A seta é desenhada em stroke (outline, como o SF
// Symbol) e o "10" é preenchido. Usado pelo tema "Safari" (id 'safari').
// Espelhado no runner.js do e-player-js (createSafariSkipSvg) para manter
// paridade entre o preview do front e o player externo.
export const SafariSkipIcon: React.FC<SafariSkipIconProps> = ({
  direction,
  className = 'h-5 w-5',
  style,
}) => {
  const back = direction === 'back';
  return (
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {back ? (
        <>
          <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
          <path d="M3 3v5h5" />
        </>
      ) : (
        <>
          <path d="M21 12a9 9 0 1 1-9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" />
          <path d="M21 3v5h-5" />
        </>
      )}
      <text
        x="12"
        y="15.4"
        textAnchor="middle"
        fontSize="8"
        fontWeight={700}
        fill="currentColor"
        stroke="none"
        fontFamily="-apple-system, BlinkMacSystemFont, 'Helvetica Neue', Arial, sans-serif"
      >
        10
      </text>
    </svg>
  );
};
